var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { EVENT_TYPE } from 'shared/utils/mixpanel';
import { TrackedCallback } from '../TrackedCallback';
export var TrackedLinkClick = function (_a) {
    var children = _a.children, eventName = _a.eventName, eventProperties = _a.eventProperties;
    return (_jsx(TrackedCallback, __assign({ eventType: EVENT_TYPE.LINK_CLICKED, callback: "onClick", eventName: eventName, eventProperties: eventProperties }, { children: children })));
};
